import React from "react";
import {
  HiOutlineCheckCircle,
  HiOutlineExclamationTriangle,
  HiOutlineInformationCircle,
  HiOutlineXCircle,
} from "react-icons/hi2";
import cn from "./cn";

const TONES = {
  info: { className: "border-sky-200 bg-sky-50 text-sky-900", icon: HiOutlineInformationCircle },
  success: { className: "border-emerald-200 bg-emerald-50 text-emerald-900", icon: HiOutlineCheckCircle },
  warning: { className: "border-amber-200 bg-amber-50 text-amber-900", icon: HiOutlineExclamationTriangle },
  danger: { className: "border-rose-200 bg-rose-50 text-rose-900", icon: HiOutlineXCircle },
  neutral: { className: "border-slate-200 bg-slate-50 text-slate-800", icon: HiOutlineInformationCircle },
};

// Inline, persistent message. Important errors belong here (in the page or
// form), not only in a transient toast.
export const Alert = ({ tone = "info", title, children, className, actions, role }) => {
  const config = TONES[tone] || TONES.info;
  const Icon = config.icon;
  return (
    <div
      role={role || (tone === "danger" || tone === "warning" ? "alert" : "status")}
      className={cn("flex gap-3 rounded-lg border px-4 py-3 text-sm leading-6", config.className, className)}
    >
      <Icon size={20} className="mt-0.5 shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        {title ? <p className="font-semibold">{title}</p> : null}
        {children ? <div className={cn(title && "mt-0.5")}>{children}</div> : null}
        {actions ? <div className="mt-2 flex flex-wrap gap-2">{actions}</div> : null}
      </div>
    </div>
  );
};

export default Alert;
